var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualityratings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "url(#paint0_linear_3025_3824)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3025_3824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6436 9.72117C16.6765 9.65477 16.7273 9.59887 16.7902 9.55979C16.8532 9.52071 16.9258 9.5 16.9999 9.5C17.074 9.5 17.1466 9.52071 17.2095 9.55979C17.2725 9.59887 17.3233 9.65477 17.3561 9.72117L19.0886 13.2304C19.2028 13.4614 19.3712 13.6612 19.5796 13.8128C19.788 13.9643 20.03 14.063 20.2849 14.1004L24.1594 14.6674C24.2328 14.6781 24.3018 14.709 24.3585 14.7568C24.4152 14.8046 24.4575 14.8673 24.4804 14.9379C24.5033 15.0084 24.5061 15.084 24.4883 15.156C24.4706 15.228 24.433 15.2936 24.3799 15.3454L21.5779 18.0739C21.3931 18.254 21.2548 18.4763 21.175 18.7216C21.0952 18.967 21.0762 19.2281 21.1196 19.4824L21.7811 23.3374C21.7941 23.4108 21.7862 23.4863 21.7583 23.5554C21.7303 23.6245 21.6836 23.6844 21.6233 23.7282C21.563 23.772 21.4916 23.7979 21.4173 23.8031C21.3429 23.8083 21.2687 23.7924 21.2029 23.7574L17.7394 21.9364C17.5112 21.8166 17.2573 21.754 16.9995 21.754C16.7418 21.754 16.4878 21.8166 16.2596 21.9364L12.7969 23.7574C12.7311 23.7922 12.6569 23.8079 12.5827 23.8026C12.5085 23.7973 12.4373 23.7713 12.3771 23.7276C12.3169 23.6838 12.2703 23.6241 12.2424 23.5551C12.2145 23.4861 12.2065 23.4107 12.2194 23.3374L12.8801 19.4832C12.9238 19.2287 12.9049 18.9675 12.825 18.722C12.7452 18.4764 12.6068 18.254 12.4219 18.0739L9.61988 15.3462C9.56633 15.2944 9.52838 15.2287 9.51036 15.1565C9.49233 15.0842 9.49496 15.0084 9.51794 14.9376C9.54093 14.8667 9.58334 14.8038 9.64034 14.7559C9.69735 14.708 9.76666 14.6771 9.84038 14.6667L13.7141 14.1004C13.9693 14.0633 14.2117 13.9647 14.4203 13.8132C14.629 13.6616 14.7977 13.4616 14.9119 13.2304L16.6436 9.72117Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3025_3824",
    x1: 0,
    y1: 17,
    x2: 34,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5BFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3025_3824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityratings);
export default __webpack_public_path__ + "static/media/qualityratings.ea9e46123aac69a6fd82ac0fef908094.svg";
export { ForwardRef as ReactComponent };